import { BaseModel } from './BaseModel';

export class Device extends BaseModel {
  hydrate(data, source) {
    this.id = data.id ?? null;
    this.position = data.position ?? null;
  }

  static fromApi(data) {
    return this.create(data, 'api');
  }

  static fromStore(data) {
    return this.create(data, 'store');
  }
}
